//Cada flow tiene una serie de componentes y un orden de ese componente, lo guardo en un arreglo
export interface Flow {
	name: string;
	steps: { number: number; component: string }[];
}

export interface OfflineDays {
	date: Date;
}

export interface ServiceAvailabilityException {
	id?: string;
	date: Date;
	services: { id: string; name: string }[];
}

export interface Shift {
	id: string;
	fromTime: string;
	toTime: string;
	name: string;
}

export interface User {
	id?: string;
	name: string;
	lastname: string;
	email: string;
	phoneNumber: string;
	password: string;
	classification?: Classification;
	roles?: Role[];
}

// I add the schedule property because when I tried to set the hour of the reservation, without the
// date of the reservation, I couldn't do it without setting a date first.
export interface Reservation {
	id?: string;
	customer: User;
	service: Service | null;
	time: Date | null;
	schedule?: string;
	state?: ReservationState;
	numberDiners: number;
	note: string;
	numberKids: number;
	numberCeliac: number;
	pets: boolean;
	paymentId?: string;
	bookingFee: number;
}

export interface Service {
	id: string;
	name: string;
	startDate: Date;
	endDate: Date | null;
	displayFrom: Date | null;
	isActive: boolean;
	maxPeoplePerReservation: number;
	schedule: Schedule;
	shifts: Shift[];
	description: string;
	shortDescription: string;
	image: string;
	category: ServiceCategory;
	price: number;
}

export interface ServiceDescription {
	id: string | null;
	name: string;
	description: string;
	shortDescription: string;
	price: number;
	image: string;
}

export interface ServiceCategory {
	name: string;
	anticipation: string;
	message: string;
	bookingFee: number;
}

export interface Schedule {
	[key: string]: string[];
}

export interface Classification {
	id: string;
	name: string;
	numberReservations: number;
}

export interface Role {
	id: string;
	name: string;
}

export interface ReservationState {
	id: string;
	name: string;
}

export interface PaymentPreferences {
	id: string;
	externalId: string;
	title: string;
	initPoint: string;
	currencyId: string;
	quantity: number;
	unitPrice: number;
}

export interface PaymentResponse {
	id: string;
	items: {
		title: string;
		quantity: number;
		unitPrice: number;
	}[];
	externalReference: string;
	initPoint: string;
	currencyId: string;
}

export interface Availabilities {
	availabilities: { [key: string]: boolean };
}

export const emptyUser = {
	name: "",
	lastname: "",
	email: "",
	phoneNumber: "",
	password: ""
};

export const emptyReservation = (customer: User) => {
	return {
		customer: customer,
		service: null,
		time: null,
		state: null,
		numberDiners: 1,
		note: "",
		numberKids: 0,
		numberCeliac: 0,
		pets: false,
		bookingFee: 0,
	};
};

export const emptyService = {
	id: "",
	name: "",
	startDate: null,
	endDate: null,
	isActive: false,
	maxPeoplePerReservation: 0,
	schedule: {},
	price: 0,
	shift: {
		id: "",
		icon: {
			name: "",
		},
		fromTime: "",
		toTime: "",
		name: "",
	},
	description: "",
	shortDescription: "",
	imageUrl: "",
	category: {
		name: "",
		anticipation: "",
		message: "",
		bookingFee: 0,
	},
};

export const emptyPayment = {
	id: "",
	externalId: "",
	title: "",
	quantity: 1,
	currencyId: "ARS",
	unitPrice: 0,
	initPoint: "",
};
